import type { AuthzResponse } from '@dfx-transfer/shared-types';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export async function fetchTransferAuthz(accessToken: string): Promise<AuthzResponse> {
  const res = await fetch(`${API_BASE}/api/v1/auth/transfer-authz`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: '{}',
  });
  if (!res.ok) {
    throw new Error(`authz failed: ${res.status}`);
  }
  return res.json();
}
